import {
  IonAlert,
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonLoading,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/react'
import { home } from 'ionicons/icons'
import React, { useState } from 'react'
import { connect } from "react-redux"
import { RouteComponentProps } from "react-router"
import EigenheimSteps from "../../components/eigenheim.steps"
import FormBirthday from "../../components/form/birthday"
import FormEmail from '../../components/form/email'
import FormFirstName from "../../components/form/first.name"
import FormGender from "../../components/form/gender"
import FormLastName from "../../components/form/last.name"
import FormMobile from '../../components/form/mobile'
import FormTitle from '../../components/form/title'
import Note from "../../components/note"
import { multilevelFallback } from '../../lib/multilevel.fallback'
import { State } from '../../store'
import { addNotification, addNotificationType } from '../../store/notification'
import { setPerson, setPersonType } from "../../store/quote"

interface StateProps {
  decoded: any
  person: any
}

interface DispatchProps {
  setPerson: setPersonType
  addNotification: addNotificationType
}

type Props = RouteComponentProps<{}> & StateProps & DispatchProps

const Person: React.FC<Props> = (props) => {
  React.useEffect(() => {
    if (!props.decoded) {
      props.history.push({ pathname: '/home' })
    }
  }, [props.decoded])

  const [exitConfirm, setExitConfirm] = useState(false)
  const [showLoading, setShowLoading] = useState(false);

  const fallback = multilevelFallback([props.person, props.decoded])

  const [title, setTitle] = useState(fallback('title'));
  const [firstName, setFirstName] = useState(fallback('firstName'));
  const [lastName, setLastName] = useState(fallback('lastName'));
  const [gender, setGender] = useState(fallback('gender'));
  const [birthday, setBirthday] = useState(fallback('birthday'));
  const [email, setEmail] = useState(fallback('email'));
  const [mobile, setMobile] = useState(fallback('mobile'));

  const confirm = async () => {
    if (!firstName) {
      props.addNotification({
        color: 'warning',
        message: 'Vorname fehlt!',
      })
      return
    }
    if (!lastName) {
      props.addNotification({
        color: 'warning',
        message: 'Nachname fehlt!'
      })
      return
    }
    if (!gender) {
      props.addNotification({
        color: 'warning',
        message: 'Geschlecht fehlt!'
      })
      return
    }
    if (!birthday) {
      props.addNotification({
        color: 'warning',
        message: 'Geburtstag fehlt!'
      })
      return
    }
    if (!email) {
      props.addNotification({
        color: 'warning',
        message: 'E-Mail fehlt!'
      })
      return
    }
    if (!/[^@]+@[^@]+\.[^@]+$/.test(email)) {
      props.addNotification({
        color: 'warning',
        message: 'E-Mail ungültig!'
      })
      return
    }
    if (!mobile) {
      props.addNotification({
        color: 'warning',
        message: 'Mobil Nummer fehlt!'
      })
      return
    }
    if (!/^(00|\+)43[0-9 \-]+/.test(mobile)) {
      props.addNotification({
        color: 'warning',
        message: 'Mobil Nummer muss mit +43 beginnen!'
      })
      return
    }

    setShowLoading(true);

    // just wait some time
    await props.setPerson({
      title,
      firstName,
      lastName,
      gender,
      birthday,
      mobile,
      email,
    })

    setShowLoading(false)

    props.history.push({ pathname: '/address' })
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color={'primary'}>
          <IonButtons slot="start">
            <IonButton onClick={() => props.history.push({ pathname: '/home' })}>
              <IonIcon slot="icon-only" icon={home} />
            </IonButton>
          </IonButtons>
          <IonTitle>Eigenheim Versicherung</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={'Verarbeite...'}
        />

        <EigenheimSteps current={0}/>

        <Note>
          Wir benötigen Informationen zu ihrer Person
        </Note>

        <IonItemGroup style={{marginLeft: -16, marginRight: -16}}>
          <IonItemDivider>
            <IonLabel>Angaben zur versicherten Person</IonLabel>
          </IonItemDivider>

          <FormTitle value={title} onChange={value => setTitle(value)} />
          <FormFirstName value={firstName} onChange={value => setFirstName(value)} />
          <FormLastName value={lastName} onChange={value => setLastName(value)} />
          <FormGender value={gender} onChange={value => setGender(value)} />
          <FormBirthday value={birthday} onChange={value => setBirthday(value)} />
        </IonItemGroup>

        <IonItemGroup style={{marginLeft: -16, marginRight: -16, marginTop: 32}}>
          <IonItemDivider>
            <IonLabel>Kontaktdaten</IonLabel>
          </IonItemDivider>

          <FormEmail value={email} onChange={value => setEmail(value)} />
          <FormMobile value={mobile} onChange={value => setMobile(value)} />
        </IonItemGroup>

        <Note>
          In der Zusammenfassung erhalten sie eine Vollständige Übersicht über die Leistungen.
        </Note>

        <IonAlert
          isOpen={exitConfirm}
          onDidDismiss={() => setExitConfirm(false)}
          header={'Neu starten?'}
          message={'Alle eingegeben Daten werden verworfen und der Prozess beginnt von vorn!'}
          /*buttons={[
            'Abbrechen',
            {
              text: 'Neu Starten!',
              handler: () => {
                props.history.push({ pathname: '/home' })
              }
            }
          ]}*/
        />
      </IonContent>
      <IonFooter>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => props.history.push({ pathname: '/home' })}>
              Home
            </IonButton>
          </IonButtons>
          <IonButton color="primary" expand={'block'} onClick={() => confirm()}>weiter</IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default connect<StateProps, DispatchProps, unknown, State>(
  ({scan, quote}) => ({
    decoded: scan.decoded,
    person: quote.person
  }),
  {
    setPerson,
    addNotification,
  }
)(Person);
